/**
 * 日期时间范围处理 Mixin
 * 功能：自动为日期范围添加时间
 * - 开始日期添加 00:00:00
 * - 结束日期添加 23:59:59
 *
 * 使用方法：
 * 1. 在组件中引入并混入: mixins: [dateTimeRangeMixin]
 * 2. 在 data 中定义 dateRange
 * 3. 在 watch 中调用 this.formatDateTimeRange(val) 或直接使用 dataForm.startDateTime 和 dataForm.endDateTime
 */
export default {
  methods: {
    /**
     * 格式化日期时间范围
     * @param {Array} dateRange - 日期范围数组 ['2025-09-30', '2025-11-30']
     * @param {Object} options - 配置选项
     * @param {String} options.startField - 开始时间字段名,默认 'startDateTime'
     * @param {String} options.endField - 结束时间字段名,默认 'endDateTime'
     * @param {String} options.startTime - 开始时间,默认 '00:00:00'
     * @param {String} options.endTime - 结束时间,默认 '23:59:59'
     * @returns {Object} - 返回格式化后的时间对象
     */
    formatDateTimeRange(dateRange, options = {}) {
      const {
        startField = 'startDateTime',
        endField = 'endDateTime',
        startTime = '00:00:00',
        endTime = '23:59:59'
      } = options

      if (!dateRange || dateRange.length === 0) {
        this.dataForm[startField] = null
        this.dataForm[endField] = null
        return {
          [startField]: null,
          [endField]: null
        }
      }

      const startDateTime = `${dateRange[0]} ${startTime}`
      const endDateTime = `${dateRange[1]} ${endTime}`

      this.dataForm[startField] = startDateTime
      this.dataForm[endField] = endDateTime

      return {
        [startField]: startDateTime,
        [endField]: endDateTime
      }
    },

    /**
     * 格式化单个日期时间
     * @param {String} date - 日期 '2025-09-30'
     * @param {String} time - 时间 '00:00:00'
     * @returns {String} - 返回格式化后的日期时间字符串
     */
    formatDateTime(date, time = '00:00:00') {
      if (!date) {
        return null
      }
      return `${date} ${time}`
    }
  }
}
